const actions = {
    PRODUCTGST_DETAILS_START: 'PRODUCTGST_DETAILS_START',
    PRODUCTGST_DETAILS_SUCCESS: 'PRODUCTGST_DETAILS_SUCCESS',
    PRODUCTGST_DETAILS_FAILURE: 'PRODUCTGST_DETAILS_FAILURE',

    TAXCODE_DETAILS_START: 'TAXCODE_DETAILS_START',
    TAXCODE_DETAILS_SUCCESS: 'TAXCODE_DETAILS_SUCCESS',
    TAXCODE_DETAILS_FAILURE: 'TAXCODE_DETAILS_FAILURE',

    OTHERTAXES_DETAILS_START: 'OTHERTAXES_DETAILS_START',
    OTHERTAXES_DETAILS_SUCCESS: 'OTHERTAXES_DETAILS_SUCCESS',
    OTHERTAXES_DETAILS_FAILURE: 'OTHERTAXES_DETAILS_FAILURE',

    CASHDISCOUNT_DETAILS_START: 'CASHDISCOUNT_DETAILS_START',
    CASHDISCOUNT_DETAILS_SUCCESS: 'CASHDISCOUNT_DETAILS_SUCCESS',
    CASHDISCOUNT_DETAILS_FAILURE: 'CASHDISCOUNT_DETAILS_FAILURE',

    PARTYGST_DETAILS_START: 'PARTYGST_DETAILS_START',
    PARTYGST_DETAILS_SUCCESS: 'PARTYGST_DETAILS_SUCCESS',
    PARTYGST_DETAILS_FAILURE: 'PARTYGST_DETAILS_FAILURE',

    CURRENCY_DETAILS_START: 'CURRENCY_DETAILS_START',
    CURRENCY_DETAILS_SUCCESS: 'CURRENCY_DETAILS_SUCCESS',
    CURRENCY_DETAILS_FAILURE: 'CURRENCY_DETAILS_FAILURE',

    WALLET_DETAILS_START: 'WALLET_DETAILS_START',
    WALLET_DETAILS_SUCCESS: 'WALLET_DETAILS_SUCCESS',
    WALLET_DETAILS_FAILURE: 'WALLET_DETAILS_FAILURE',

    MOP_DETAILS_START: 'MOP_DETAILS_START',
    MOP_DETAILS_SUCCESS: 'MOP_DETAILS_SUCCESS',
    MOP_DETAILS_FAILURE: 'MOP_DETAILS_FAILURE',

    HSN_DETAILS_START: 'HSN_DETAILS_START',
    HSN_DETAILS_SUCCESS: 'HSN_DETAILS_SUCCESS',
    HSN_DETAILS_FAILURE: 'HSN_DETAILS_FAILURE'
};

export default actions;